// extracted by mini-css-extract-plugin
export default {"visio":"qyIbF1JlxQncTTizUog7"};